import type { MessageDescriptor } from 'react-intl-next';

import { extractToken } from '../color-conversion';
import { allHumanReadableColors } from '../constants';

type BuiltInColorMapParams = {
	allColors?: string[];
	getResponsiveColor?: (color: string) => string;
	humanReadableColors?: Map<string, MessageDescriptor>;
	knownColors: string[];
};

export const createBuiltInColorMap = ({
	knownColors,
	allColors,
	humanReadableColors,
	getResponsiveColor,
}: BuiltInColorMapParams): {
	allColors: string[];
	allTokens: string[];
	getResponsiveColor: (color: string) => string;
	humanReadableColors: Map<string, MessageDescriptor>;
	knownColors: string[];
	knownTokens: string[];
} => {
	knownColors = knownColors.map((color) => color.toLowerCase());
	const knownTokens = knownColors.map((color) => extractToken(color));

	if (!allColors) {
		allColors = knownColors;
	} else {
		allColors = allColors.map((color) => color.toLowerCase());
	}

	const allTokens = allColors.map((color) => extractToken(color));
	const humanReadableColorsMap = humanReadableColors
		? new Map([...allHumanReadableColors.entries(), ...humanReadableColors.entries()])
		: allHumanReadableColors;

	return {
		knownColors,
		knownTokens,
		allColors,
		allTokens,
		humanReadableColors: humanReadableColorsMap,
		getResponsiveColor: getResponsiveColor || ((color: string) => color),
	};
};

export type BuiltInColorMap = {
	allColors: string[];
	allTokens: string[];
	getResponsiveColor: (color: string) => string;
	humanReadableColors: Map<string, MessageDescriptor>;
	knownColors: string[];
	knownTokens: string[];
};
